import { IFormatObjectEditable } from "..";
import { IFormatAlert } from "../IFormatAlert";
import { IObjectValidator } from "../IObjectValidator";
import { BarcodeObjectEditor } from "../objectEditors";
import { ObjectAlert } from "../alerts";

export class BarcodeObjectValidator implements IObjectValidator {
  public validate(object: IFormatObjectEditable): IFormatAlert[] {
    const alerts: ObjectAlert[] = [];
    if (object instanceof BarcodeObjectEditor) {
      if (!object.barcodeItems().getValue() || object.barcodeItems().getValue().length < 1) {
        alerts.push(new ObjectAlert(object, "データ項目を設定してください。"));
      }
    }
    return alerts;
  }
}
